import { AppContainer, ConfirmationDialogProvider, NavContainer, NavContainerPinnedProvider } from '@procureai/ui-mui';
import { Outlet } from 'react-router-dom';

import { AppNavBar } from '~/components/AppNavBar/AppNavBar';
import { AppNavDrawer } from '~/components/AppNavDrawer';
import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { ExtensionPurchaseReqNumberContextProvider } from '~/components/ExtensionPurchaseRequisitionNumber/extensionPurchaseReqNumberProvider';
import { useActiveScope } from '~/hooks/useActiveScope/useActiveScope';

import { useAppContent } from './AppContent.hooks';

export const AppContent = () => {
  const { showNavbar, loading, hover, pinned, setAppState, onContainerMouseOver, onContainerMouseLeave } =
    useAppContent();

  const { activeScope } = useActiveScope();
  if (loading) {
    return <CircularProgressCentered color="inherit" />;
  }

  return (
    <>
      {showNavbar && (
        <NavContainer
          onMouseOver={onContainerMouseOver}
          onMouseLeave={onContainerMouseLeave}
          bar={<AppNavBar />}
          drawer={
            <AppNavDrawer
              open={hover}
              pinned={pinned}
              onPinToggle={(navDrawerPinned) => {
                setAppState((prev) => ({
                  ...prev,
                  navDrawerPinned,
                }));
              }}
            />
          }
        />
      )}

      <NavContainerPinnedProvider value={pinned}>
        <ConfirmationDialogProvider>
          <AppContainer showNavbar={showNavbar}>
            <ExtensionPurchaseReqNumberContextProvider>
              <Outlet key={activeScope} />
            </ExtensionPurchaseReqNumberContextProvider>
          </AppContainer>
        </ConfirmationDialogProvider>
      </NavContainerPinnedProvider>
    </>
  );
};
